import moment from 'moment-timezone';

moment.updateLocale('en', {
    relativeTime: {
        ss: "%d seconds"
    }
});
